module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMTYgMjAiIHdpZHRoPSIxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjMDA3M0MyIiBkPSJtNjY4IDQwMnYxOS41NjI1bDE1LjcxMDkzOC05LjI4MTI1eiIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjY4IC00MDIpIi8+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/images/global-play.svg
// module id = 476
// module chunks = 0